import { Link } from "react-router-dom";
import { MOVIE } from "@/constants/site";

const scrollToForm = (e) => {
  e?.preventDefault();
  const el = document.getElementById("inquiry");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  return (
    <header className="fixed top-0 inset-x-0 z-50 nav-blur" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="nav-home-link"
        >
          <span className="inline-block h-2.5 w-2.5 rounded-full bg-fs-orange shadow-[0_0_12px_2px_rgba(255,138,30,0.6)]" />
          <span className="font-display text-xl sm:text-2xl tracking-wider text-fs-cream">
            {MOVIE.title}
            <span className="text-fs-gold"> · </span>
            <span className="text-fs-silver text-base sm:text-lg">
              {MOVIE.subtitle}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm text-fs-silver">
          <a
            href="#about"
            className="hover:text-fs-gold transition-colors"
            data-testid="nav-about-link"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("about")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            The Film
          </a>
          <a
            href="#press"
            className="hover:text-fs-gold transition-colors"
            data-testid="nav-media-link"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("press")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Press
          </a>
          <a
            href="#follow"
            className="hover:text-fs-gold transition-colors"
            data-testid="nav-follow-link"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("follow")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Follow
          </a>
        </nav>

        <button
          type="button"
          onClick={scrollToForm}
          className="btn-fs-primary !py-2 !px-5 !text-sm"
          data-testid="nav-contact-cta"
        >
          Contact Us
        </button>
      </div>
    </header>
  );
}
